import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useMemo } from 'react';
import { getConf } from '@jbrowse/core/configuration';
import { SanitizedHTML } from '@jbrowse/core/ui';
import { observer } from 'mobx-react';
import { Portal, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { usePopper } from 'react-popper';
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var useStyles = makeStyles()(function (theme) {
  return {
    // these styles come from
    // https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Tooltip/Tooltip.js
    tooltip: {
      pointerEvents: 'none',
      backgroundColor: alpha(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word'
    }
  };
});
var TooltipContents = React.forwardRef(function (_ref, ref) {
  var message = _ref.message;
  return React.createElement("div", {
    ref: ref
  }, React.isValidElement(message) ? message : message ? React.createElement(SanitizedHTML, {
    html: String(message)
  }) : null);
});
var Tooltip = observer(function (_ref2) {
  var model = _ref2.model,
    clientMouseCoord = _ref2.clientMouseCoord;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var featureUnderMouse = model.featureUnderMouse;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElt = _useState4[0],
    setPopperElt = _useState4[1]; // must be memoized a la https://github.com/popperjs/react-popper/issues/391
  var virtElement = useMemo(function () {
    return {
      getBoundingClientRect: function getBoundingClientRect() {
        var x = clientMouseCoord[0] + width / 2 + 20;
        var y = clientMouseCoord[1];
        return {
          top: y,
          left: x,
          bottom: y,
          right: x,
          width: 0,
          height: 0,
          x: x,
          y: y,
          toJSON: function toJSON() {}
        };
      }
    };
  }, [clientMouseCoord, width]);
  var _usePopper = usePopper(virtElement, popperElt),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var contents = featureUnderMouse ? getConf(model, 'mouseover', {
    feature: featureUnderMouse
  }) : undefined;
  return featureUnderMouse && contents ? React.createElement(Portal, null, React.createElement("div", _objectSpread({
    ref: setPopperElt,
    className: classes.tooltip,
    // zIndex needed to go over widget drawer
    style: _objectSpread({}, styles.popper, {
      zIndex: 100000
    })
  }, attributes.popper), React.createElement(TooltipContents, {
    ref: function ref(elt) {
      return setWidth((elt === null || elt === void 0 ? void 0 : elt.getBoundingClientRect().width) || 0);
    },
    message: contents
  }))) : null;
});
export default Tooltip;